<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-2">
        <span class="text-3xl" :style="{ color: typeColor }">💼</span>
        <span>职业发展建议</span>
      </h2>
      <p class="text-gray-600 text-lg">为您的职业规划提供参考</p>
    </div>

    <ul class="space-y-0 divide-y divide-gray-100">
      <li 
        v-for="(item, index) in recommendations"
        :key="index"
        class="py-4 first:pt-0 last:pb-0"
      >
        <div class="flex items-start gap-4">
          <div 
            class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-bold"
            :style="{ backgroundColor: typeColor }"
          >
            {{ index + 1 }}
          </div>
          <p class="text-base leading-relaxed text-gray-800 font-medium pt-1">
            {{ item }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 职业发展建议组件
 * 展示针对特定Holland类型的职业发展建议
 */
export default {
  name: 'CareerAdvice',
  props: {
    recommendations: {
      type: Array,
      required: true
    },
    typeColor: {
      type: String,
      required: true
    }
  }
}
</script>

